  import React from "react";
  import { useEffect, useState } from "react";
  import { Link, useNavigate, useParams } from "react-router-dom";
  import { useSelector, useDispatch } from "react-redux";
  import { InputText } from "primereact/inputtext";
  import { Message } from "primereact/message";
  import { Button } from "primereact/button";
  import { Card } from "primereact/card";
  import {
    ActivePasswordAction,
    ChangePasswordAction,
    ValidateToken,
  } from "../../../../store/auth-store/auth-actions";
  import { uiActions } from "../../../../store/ui-slice";
  import ABAColor from "../../../../Assets/Img/ABAColor.png";
  import "./ChangePassword.css";
  import { useLocation } from "react-router-dom";
  import { GetUserInfo } from "../../../../store/user-store/user-actions";
  import { getTokenInfo, logOut } from "../../../../utils/Guard";

  let restartPage = false;
  // let showinfo =false;

  const ChangePassword = () => {
    const params = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const notification = useSelector((state) => state.ui.notification);
    const userInfo = getTokenInfo();
    const [password, setPassword] = useState("");
    const [repassword, setRePassword] = useState("");
    const [passwordIsValid, setPasswordIsvalid] = useState(true);
    const [repasswordIsValid, setRePasswordIsValid] = useState(true);
    const [showPassword, setShowPassword] = useState(false);
    const [reshowPassword, setReShowPassword] = useState(false);
    const [showinfo, setShowInfo] = useState(false);

    const header = (
      <img alt="Card" className="changePasswordImage" src={ABAColor} />
    );
    
    useEffect(() => {
      if (params.userId && params.token) {

        dispatch(ValidateToken(params.token, params.userId));
      }
    }, [dispatch, params.token, params.userId]);

    useEffect(() => {
      if (
        showinfo === false &&
        notification !== undefined &&
        notification!==null &&
        notification.status === "success" ||(
          userInfo!==null && userInfo.TemporalPassword === "True")
      ) {
        setShowInfo(true);
      }
    }, [showinfo, notification]);

    useEffect(() => {
      if (notification && notification.status === "success" && restartPage) {
        window.location.href = "/login";
      }
      
    }, [navigate, notification]);

    const validatePassword = (password) => {
      const minLength = 6;
      const hasUpperCase = /[A-Z]/.test(password);
      const hasLowerCase = /[a-z]/.test(password);
      const hasNumber = /\d/.test(password);
      const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password);
  
      if (
        password.length >= minLength &&
        hasUpperCase &&
        hasLowerCase &&
        hasNumber &&
        hasSpecialChar
      ) {
        return true;
      }
  
      return false;
    };

    const onSubmitHandler = (event) => {
      event.preventDefault();
      if (password === "") {
        setPasswordIsvalid(false);
        dispatch(
          uiActions.showNotification({
            status: "warning",
            title: "Advertencia",
            message: "Favor completar el campo contraseña",
          })
        );
      } else if (repassword === "") {
        setRePasswordIsValid(false);
        dispatch(
          uiActions.showNotification({
            status: "warning",
            title: "Advertencia",
            message: "Favor completar el campo confirmar contraseña",
          })
        );
      } else if (password !== repassword) {
        dispatch(
          uiActions.showNotification({
            status: "warning",
            title: "Advertencia",
            message: "Las contraseñas no coinciden",
          })
        );
      }
        else if (validatePassword(password) === false) {
          dispatch(
            uiActions.showNotification({
              status: "warning",
              title: "Advertencia",
              message: "La contraseña debe tener al menos 6 caracteres, una letra mayúscula, una letra minúscula, un número y un carácter especial.",
            })
          );
        }
       else {
        if (
          (params.token === null || params.token === undefined) &&
          location.pathname == "/auth/changepassword/" + userInfo.id
        ) {
          dispatch(ActivePasswordAction(params.userId, password));
        
        } else {
          
          dispatch(ChangePasswordAction(params.token, params.userId, password));
        }
        setTimeout(() => {
          logOut()
          window.location.href="/login"
        }, 1500);

      }
    };

    return (
      <>
        {showinfo && (
          <div className="card flex justify-content-center changePasswordBody">
            <div className="formgrid grid ">
              <div className="field col-12 md:col-12">
                <Card className="changePasswordCard">
                  <div className="field col-12 md:col-2"></div>
                  <div className="field col-12 md:col-5">{header}</div>
                  <div className="field col-12 md:col-3"></div>
                  <div className="field col-12 md:col-12 changePasswordTitle">
                    <span className="changePasswordTitleText">
                      Recuperar contraseña
                    </span>
                  </div>
                  <form onSubmit={onSubmitHandler}>
                    <div className="formgrid grid">
                      <div className="field col-12 md:col-12">
                        <InputText
                          className="changePasswordemailTextBox"
                          type={showPassword === false ? "password" : "text"}
                          id={password}
                          value={password}
                          onChange={(e) => {
                            if (validatePassword(e.target.value)) {
                              setPasswordIsvalid(true);
                            } else {
                              setPasswordIsvalid(false);
                            }
                            setPassword(e.target.value);
                          }}
                          placeholder="Contraseña"
                        />
                        <Link
                          className="changePasswordshowPassword"
                          onClick={() => {
                            setShowPassword(!showPassword);
                          }}
                        >
                          <i
                            className={
                              showPassword === false
                                ? "pi pi-eye"
                                : "pi  pi-eye-slash"
                            }
                          ></i>
                        </Link>
                      </div>
                      <div className="field col-12 md:col-12">
                        <InputText
                          type={reshowPassword === false ? "password" : "text"}
                          className="changePasswordemailTextBox"
                          id={repassword}
                          value={repassword}
                          onChange={(e) => {
                            if (e.target.value.length > 0) {
                              setRePasswordIsValid(true);
                            } else {
                              setRePasswordIsValid(false);
                            }
                            setRePassword(e.target.value);
                          }}
                          placeholder="Repetir Contraseña"
                        />
                        <Link
                          className="changePasswordshowPassword"
                          onClick={() => {
                            setReShowPassword(!reshowPassword);
                          }}
                        >
                          <i
                            className={
                              reshowPassword === false
                                ? "pi pi-eye"
                                : "pi  pi-eye-slash"
                            }
                          ></i>
                        </Link>
                      </div>
                      <div style={{marginTop:"6.5%", width:"100%", display:"flex"}}>
                      <div className="field col-12 md:col-6">
                        <Button
                          label="Regresar"
                          className="changePasswordButtonBack"
                          onClick={() => {
                            navigate(`/login`);
                          }}
                        />
                      </div>
                      
                      <div className="field col-12 md:col-6 ">
                        <Button
                          label="Solicitar"
                          className="changePasswordButton"
                          icon={
                            notification && notification.status === "pending"
                              ? "pi pi-spin pi-spinner"
                              : ""
                          }
                          disabled={
                            notification && notification.status === "pending"
                          }
                        />
                      </div>
                      </div>
                    </div>
                  </form>
                </Card>
              </div>
            </div>
          </div>
        )}
        {!showinfo && (
          <>
          <div
          style={{ backgroundColor: "#133047", padding: "1%", height: "137vh" }}
        >
          <Card
            title="Error al validar el token"
            subTitle="Favor verificar que la url a la que intenta acceder es correcta."

            style={{ width: "100%" }}
          >
            <Button
              className="p-button-danger"
              onClick={() => {
                  navigate(`  /`);
              }}
            >
              Atrás
            </Button>
          </Card>

        
        </div>
          </>
        )}
      </>
    );
  };
  export default ChangePassword;
